import axios from "axios";
import { API } from "./api";

export async function fetchSite() {
  const { data } = await axios.get(`${API}/public/site`);
  return data || {};
}

export async function fetchPublicCourses() {
  const { data } = await axios.get(`${API}/public/courses`);
  return data || [];
}

export async function fetchPublicCourse(cid) {
  const { data } = await axios.get(`${API}/public/courses/${cid}`);
  return data;
}

export async function sendEnquiry(payload) {
  const { data } = await axios.post(`${API}/public/enquiries`, payload);
  return data;
}
